var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.simulation.offerParams.isCreditInsuranceAccelerated,
          expression: "simulation.offerParams.isCreditInsuranceAccelerated",
        },
      ],
      staticClass: "subcard is-gray",
    },
    [
      _c(
        "div",
        { staticClass: "subcard-header" },
        [
          _c("p", { staticClass: "header-title" }, [_vm._v("Cuota máxima")]),
          _c("b-button", {
            staticClass: "header-icon",
            attrs: {
              size: "is-small",
              "icon-left": _vm.localShow ? "angle-up" : "angle-down",
            },
            on: { click: _vm.toggle },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.localShow,
              expression: "localShow",
            },
          ],
          staticClass: "subcard-content fields-has-text-right",
        },
        [
          _c(
            "b-field",
            { staticClass: "has-addons", attrs: { "custom-class": "columns" } },
            [
              _c(
                "div",
                {
                  staticClass:
                    "column is-4 is-flex is-align-items-center is-flex-direction-column",
                },
                [
                  _c(
                    "small",
                    { staticClass: "text-center has-text-grey-light pr-1" },
                    [_vm._v(" ")]
                  ),
                  _c(
                    "div",
                    { staticClass: "field has-addons" },
                    [
                      _c("p", { staticClass: "control" }, [
                        _c("a", { staticClass: "button is-static" }, [
                          _vm._v("UF"),
                        ]),
                      ]),
                      _c("b-input", {
                        attrs: {
                          disabled: _vm.readOnly,
                          size: "is-small",
                          type: _vm.determineInputType(
                            _vm.firstFeeMaxPayment()
                          ),
                          placeholder: "Ingresa el valor",
                          value: _vm.firstFeeMaxPayment(),
                          expanded: "",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "column is-4 is-flex is-align-items-center is-flex-direction-column",
                },
                [
                  _c(
                    "small",
                    { staticClass: "text-center has-text-grey-light pr-1" },
                    [_vm._v("entre")]
                  ),
                  _c(
                    "div",
                    { staticClass: "field has-addons" },
                    [
                      _c("p", { staticClass: "control" }, [
                        _c("a", { staticClass: "button is-static" }, [
                          _vm._v("Cuota"),
                        ]),
                      ]),
                      _c("b-input", {
                        attrs: {
                          value: _vm.firstPaymentStart(),
                          disabled: _vm.readOnly,
                          size: "is-small",
                          type: _vm.determineInputType(_vm.firstPaymentStart()),
                          placeholder: "Ingresa el valor",
                          expanded: "",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "column is-4 is-flex is-align-items-center is-flex-direction-column",
                },
                [
                  _c(
                    "small",
                    { staticClass: "text-center has-text-grey-light pr-1" },
                    [_vm._v("y")]
                  ),
                  _c(
                    "div",
                    { staticClass: "field has-addons" },
                    [
                      _c("p", { staticClass: "control" }, [
                        _c("a", { staticClass: "button is-static" }, [
                          _vm._v("Cuota"),
                        ]),
                      ]),
                      _c("b-input", {
                        attrs: {
                          value: _vm.firstPaymentEnd(),
                          disabled: _vm.readOnly,
                          size: "is-small",
                          type: _vm.determineInputType(_vm.firstPaymentEnd()),
                          placeholder: "Ingresa el valor",
                          expanded: "",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
          _c(
            "b-field",
            { staticClass: "has-addons", attrs: { "custom-class": "columns" } },
            [
              _c(
                "div",
                {
                  staticClass:
                    "column is-4 is-flex is-align-items-center is-flex-direction-column",
                },
                [
                  _c(
                    "small",
                    { staticClass: "text-center has-text-grey-light pr-1" },
                    [_vm._v(" ")]
                  ),
                  _c(
                    "div",
                    { staticClass: "field has-addons" },
                    [
                      _c("p", { staticClass: "control" }, [
                        _c("a", { staticClass: "button is-static" }, [
                          _vm._v("UF"),
                        ]),
                      ]),
                      _c("b-input", {
                        attrs: {
                          value: _vm.lastFeeMaxPayment(),
                          disabled: _vm.readOnly,
                          size: "is-small",
                          type: _vm.determineInputType(_vm.lastFeeMaxPayment()),
                          placeholder: "Ingresa el valor",
                          expanded: "",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "column is-4 is-flex is-align-items-center is-flex-direction-column",
                },
                [
                  _c(
                    "small",
                    { staticClass: "text-center has-text-grey-light pr-1" },
                    [_vm._v("entre")]
                  ),
                  _c(
                    "div",
                    { staticClass: "field has-addons" },
                    [
                      _c("p", { staticClass: "control" }, [
                        _c("a", { staticClass: "button is-static" }, [
                          _vm._v("Cuota"),
                        ]),
                      ]),
                      _c("b-input", {
                        attrs: {
                          value: _vm.lastPaymentStart(),
                          disabled: _vm.readOnly,
                          size: "is-small",
                          type: _vm.determineInputType(_vm.lastPaymentStart()),
                          placeholder: "Ingresa el valor",
                          expanded: "",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "column is-4 is-flex is-align-items-center is-flex-direction-column",
                },
                [
                  _c(
                    "small",
                    { staticClass: "text-center has-text-grey-light pr-1" },
                    [_vm._v("y")]
                  ),
                  _c(
                    "div",
                    { staticClass: "field has-addons" },
                    [
                      _c("p", { staticClass: "control" }, [
                        _c("a", { staticClass: "button is-static" }, [
                          _vm._v("Cuota"),
                        ]),
                      ]),
                      _c("b-input", {
                        attrs: {
                          value: _vm.lastPaymentEnd(),
                          disabled: _vm.readOnly,
                          size: "is-small",
                          type: _vm.determineInputType(_vm.lastPaymentEnd()),
                          placeholder: "Ingresa el valor",
                          expanded: "",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }